
import { useMemo } from 'react';

export interface TrafficCondition {
  level: 'low' | 'moderate' | 'heavy';
  color: string;
  delayFactor: number;
}

export const useTrafficConditions = () => {
  // Traffic conditions mapping. Memoized so the returned object keeps a stable
  // identity across renders — consumers put it in useCallback/useEffect
  // dependency arrays (useRouting.getRoute, useRouteRenderer.addRouteToMap), and
  // a fresh object every render would retrigger those and cause render loops.
  const trafficConditions: Record<string, TrafficCondition> = useMemo(() => ({
    'low': {
      level: 'low',
      color: '#22c55e', // green
      delayFactor: 1
    },
    'moderate': {
      level: 'moderate',
      color: '#f97316', // orange
      delayFactor: 1.3
    },
    'heavy': {
      level: 'heavy',
      color: '#dc2626', // red
      delayFactor: 1.6
    }
  }), []);

  return { trafficConditions };
};
